import React, { useState } from "react";
import { Reply, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { streamSSE } from "@/lib/sse";

const when = (iso) => { try { return new Date(iso).toLocaleString(); } catch { return iso; } };

export const TeacherEnquiryReply = ({ enquiry, i, onReplied, kind = "teacher" }) => {
  const [replies, setReplies] = useState(enquiry.replies || []);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [drafting, setDrafting] = useState(false);
  const draft = async () => {
    setDrafting(true); setMsg("");
    try { await streamSSE(`/admin/${kind}-enquiries/${enquiry.id}/draft`, {}, (d) => setMsg((m) => m + d)); }
    catch (e) { toast.error(e.message); }
    finally { setDrafting(false); }
  };
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/${kind}-enquiries/${enquiry.id}/reply`, { message: msg });
      setReplies([...replies, data.reply]); onReplied?.(data.reply); setMsg(""); setOpen(false); toast.success(`Reply emailed to ${enquiry.email}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Could not send the reply"); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-3">
      {replies.map((r, j) => (
        <div key={j} className="mt-2 rounded-xl bg-primary/10 p-3 text-sm" data-testid={`${kind}-enquiry-reply-${i}-${j}`}>
          <p className="font-mono text-[10px] uppercase tracking-widest text-primary">Replied {when(r.sent_at)}</p>
          <p className="mt-1 whitespace-pre-line">{r.message}</p>
        </div>
      ))}
      {open ? (
        <div className="mt-3 space-y-2">
          <textarea rows={8} value={msg} onChange={(e) => setMsg(e.target.value)} placeholder={`Reply to ${enquiry.name}…`} data-testid={`${kind}-enquiry-reply-input-${i}`}
            className="w-full rounded-xl border border-border bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none" />
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={draft} disabled={busy || drafting} data-testid={`${kind}-enquiry-draft-${i}`}
              className="inline-flex items-center gap-1.5 rounded-full border border-primary px-4 py-2 text-sm font-semibold text-primary disabled:opacity-60">
              {drafting ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />} {msg ? "Redraft with AI" : "Draft with AI"}
            </button>
            <button type="button" onClick={send} disabled={busy || !msg.trim()} data-testid={`${kind}-enquiry-reply-send-${i}`}
              className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground disabled:opacity-60">
              {busy && <Loader2 size={14} className="animate-spin" />} Send reply
            </button>
            <button type="button" onClick={() => setOpen(false)} data-testid={`${kind}-enquiry-reply-cancel-${i}`} className="rounded-full border border-border px-4 py-2 text-sm">Cancel</button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={() => setOpen(true)} data-testid={`${kind}-enquiry-reply-btn-${i}`}
          className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-primary px-4 py-1.5 text-sm font-semibold text-primary hover:bg-primary hover:text-primary-foreground">
          <Reply size={14} /> {replies.length ? "Reply again" : "Reply"}
        </button>
      )}
    </div>
  );
};
